import { Pipe, PipeTransform } from '@angular/core';
import { deployUrl } from '../deploy-url';

@Pipe({
  name: 'deployUrl',
})
export class DeployUrlPipe implements PipeTransform {
  transform(path: string): string {
    return deployUrl(path);
  }
}
